<div class="wm-select-test">
    @if (loading) {
        <div class="wm-select-test-loading">
            <p-progressSpinner></p-progressSpinner>
            <div class="wm-select-test-loading-text">Loading available tests...</div>
        </div>
    } @else {
        @for (group of cardGroups; track group.id) {
            <div class="wm-select-test-section">
                <div class="wm-select-test-section-title">{{group.title}}</div>
                <div class="wm-select-test-grid">
                    @for (card of group.cards; track card.id) {
                        <button class="wm-select-test-tile" type="button" (click)="card.onClick()">
                            <div class="wm-select-test-tile-top">
                                <div class="wm-select-test-tile-title" [attr.title]="card.title">{{card.title}}</div>
                                @if (card.badgeLabel) {
                                    <div class="wm-select-test-tile-badge">{{card.badgeLabel}}</div>
                                }
                            </div>
                            @if (card.description) {
                                <div class="wm-select-test-tile-subtitle">{{card.description}}</div>
                            }
                            @if (card.detailsTemplate) {
                                <ng-container [ngTemplateOutlet]="card.detailsTemplate" [ngTemplateOutletContext]="{$implicit: card.detailsContext}"></ng-container>
                            }
                        </button>
                    }
                </div>
            </div>
        }
    }
</div>

<ng-template #auditCardDetails let-details>
    <div class="wm-select-test-audit-list-visualization">
        <div class="audit-summary-row">
            @if (details.templateName) {
                <div class="template-name">
                    {{ details.templateName }}
                </div>
            }
            <div class="findings-info">
                {{ details.findingsInfo.totalCount }} {{ details.findingsInfo.totalCount === 1 ? 'Finding' : 'Findings' }}
            </div>
        </div>
        <div class="activity-info">
            <wm-activity-info-chart [activityInfo]="details.activityInfo"></wm-activity-info-chart>
        </div>
    </div>
</ng-template>
